import { FormFieldData, FormSetupData, FormWizardData } from '../types';
import { FormUpdateRequestApi } from '../types/formCreateApi';
import {
  getUpdatedFormFields,
  mapFormFieldToUpdateApi
} from './getUpdatedFormFields';
import {
  appendCoverImageToRequest,
  mapDiscountConfig,
  mapStartCollectionFrom
} from './mapWizardToCreateFormRequest';
import { getFormFieldGlobalDisplayOrder } from './sortFormFieldsForApiOrder';

const appendSetupFields = (
  request: FormUpdateRequestApi,
  setup: FormSetupData
) => {
  const isGroupMode = setup.addToMode === 'group';

  if (isGroupMode && setup.groupId) {
    request.group_id = setup.groupId;
  }
  if (isGroupMode && setup.startCollectionFrom) {
    request.start_collection_from = mapStartCollectionFrom(
      setup.startCollectionFrom
    );
  }
  if (setup.maxRegistrations !== undefined) {
    request.registration_max_count = setup.maxRegistrations;
  }
  if (setup.autoCloseDate) {
    request.registration_end_time = setup.autoCloseDate;
  }
  if (setup.acceptInstallments && setup.minPartialPaymentAmount !== undefined) {
    request.min_partial_payment_amount = setup.minPartialPaymentAmount;
  }
};

export const mapWizardToUpdateFormRequest = async (
  wizardData: FormWizardData,
  originalFields: FormFieldData[]
): Promise<FormUpdateRequestApi> => {
  const { setup, fields } = wizardData;
  const updatedFields = getUpdatedFormFields(originalFields, fields);

  const request: FormUpdateRequestApi = {
    name: setup.name,
    description: setup.description ?? '',
    add_to_mode: setup.addToMode,
    fee_amount: setup.feeAmount ?? 0,
    is_partial_payment_enabled: setup.acceptInstallments ?? false,
    discount_config: mapDiscountConfig(setup),
    form_fields: updatedFields.map((field) =>
      mapFormFieldToUpdateApi(
        field,
        getFormFieldGlobalDisplayOrder(field, fields, originalFields)
      )
    )
  };

  await appendCoverImageToRequest(request, setup);

  appendSetupFields(request, setup);

  return request;
};

export default mapWizardToUpdateFormRequest;
